import { juOnFinishOrder } from 'vue-src/utils/ju_tracking.js'

export const CartCreate = async function () {
  if (!window.gtag) {
    return
  }

  window.gtag("event", "page_view", {
    page_title: 'cart-create',
    page_location: '/funnel_G1/cart.html',
  })
}

export const HeaderCreate = async function () {
  if (!window.gtag) return
  window.gtag("event", "page_view", {
    page_title: 'header-create',
    page_location: '/funnel_G1/header.html',
  })
}

export const PaymentButton = async function () {
  if (!window.gtag) return

  window.gtag("event", "page_view", {
    page_title: "payment",
    page_location: "/funnel_G1/payment.html",
  })
}

export const finishCustomerOrder = async function (cart, line_items) {
  if (window.gtag) {
    const items = line_items.map(item => {
      return {
        item_id: item.stock_number,
        price: item.price,
        quantity: item.quantity,
        item_name: item.product_name,
      }
    })
    window.gtag(
      "event", "purchase", {
        transaction_id: cart.reference_code,
        value: cart.cart_total,
        tax: cart.tax_amount,
        shipping: cart.estimated_shipping,
        currency: "USD",
        items,
      }
    )
    window.gtag("event", "page_view", {page_tite: "thank you", page_location: '/funnel_G1/thankyou.html'})
  }

  juOnFinishOrder(cart, line_items)
}

export default {
  CartCreate,
  HeaderCreate,
  PaymentButton,
  finishCustomerOrder
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/utils/tracking.js